import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=218536bb&scoped=true&"
import script from "./Step5.vue?vue&type=script&lang=js&"
export * from "./Step5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218536bb",
  null
  
)

export default component.exports